import React from "react";
import { Component } from "react";
import { Col, Row } from "reactstrap";
import { NavLink } from "react-router-dom";
import Logo3 from "../../website/home/assets/img/givbeeLogo.png";
import "./VerifyAccount.css";
import { withRouter } from "../../../withRouter";
import PtsAlert from "../ptsAlert/PtsAlert";
import Header from "../../website/home/Header";
import Footer from "../../website/home/Footer";
import FetchServerData from "../../../provider/FetchServerData";
import {
  PostVerifyAccount_Url,
  Static_Url,
  StaticEventText_Url,
  VerifyAccount_Url,
} from "../../../provider/ServiceUrl";
import store from "../../../redux/store";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
import SelectedTabAction from "../../../redux/selectedTab/SelectedTabAction";
import ActiveMenuAction from "../../../redux/activeMenu/ActiveMenuAction";
import staticDataAction from "../../../redux/staticData/staticDataAction";
import CrmIntegrationAction from "../../../redux/crmIntegration/CrmIntegrationAction";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import Utils from "../../../provider/Utils";
import AccountSettingDataAction from "../../../redux/accountSetting/AccountSettingDataAction";
import headerAction from "../../../redux/header/headerAction";
export class VerifyAccount extends Component {
  constructor(props) {
    super(props);
    let email = props.email;
    let orderPaymentId = props.orderPaymentId;
    if (props.state) {
      email = props.state.email;
      orderPaymentId = props.state.orderPaymentId;
    }
    this.state = {
      name: "",
      email: email,
      referralCode: "",
      showPassword: false,
      showConfirmPassword: false,
      orderPaymentId: orderPaymentId,
      value1: "",
      value1Ref: React.createRef(),
      value2: "",
      value2Ref: React.createRef(),
      value3: "",
      value3Ref: React.createRef(),
      value4: "",
      value4Ref: React.createRef(),
      value5: "",
      value5Ref: React.createRef(),
      value6: "",
      value6Ref: React.createRef(),
    };
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    this.state.value1Ref.current.focus();
  }

  handleValueChange = async (e) => {
    const { name, value } = e.target;

    if (e.key === "Backspace") {
      return;
    }
    if (value.length > 1) {
      PtsAlert.error("Please enter a single digit");
      return;
    }

    await this.setState({ [name]: value });

    switch (name) {
      case "value1":
        this.value2Focus();
        this.value2Select();
        break;
      case "value2":
        this.value3Focus();
        this.value3Select();
        break;
      case "value3":
        this.value4Focus();
        this.value4Select();
        break;
      case "value4":
        this.value5Focus();
        this.value5Select();
        break;
      case "value5":
        this.value6Focus();
        this.value6Select();
        break;
      case "value6":
        // this.VerifyOtpInBackend();
        break;
      default:
        break;
    }
  };

  handleKeyUp = (e) => {
    const { name } = e.target;

    if (e.key === "Enter") {
      this.VerifyOtpInBackend();
    } else if (e.key === "Backspace") {
      this.setState({ [name]: "" });

      switch (name) {
        case "value1":
          break;
        case "value2":
          this.setState({ value1: "" });
          this.value1Focus();
          break;
        case "value3":
          this.setState({ value2: "" });
          this.value2Focus();
          break;
        case "value4":
          this.setState({ value3: "" });
          this.value3Focus();
          break;
        case "value5":
          this.setState({ value4: "" });
          this.value4Focus();
          break;
        case "value6":
          this.setState({ value5: "" });
          this.value5Focus();
          break;
        default:
          break;
      }
    } else if (e.key === "ArrowLeft") {
      switch (name) {
        case "value1":
          break;
        case "value2":
          this.value1Focus();
          this.value1Select();
          break;
        case "value3":
          this.value2Focus();
          this.value2Select();
          break;
        case "value4":
          this.value3Focus();
          this.value3Select();
          break;
        case "value5":
          this.value4Focus();
          this.value4Select();
          break;
        case "value6":
          this.value5Focus();
          this.value5Select();
          break;
        default:
          break;
      }
    } else if (e.key === "ArrowRight") {
      switch (name) {
        case "value1":
          this.value2Focus();
          this.value2Select();
          break;
        case "value2":
          this.value3Focus();
          this.value3Select();
          break;
        case "value3":
          this.value4Focus();
          this.value4Select();
          break;
        case "value4":
          this.value5Focus();
          this.value5Select();
          break;
        case "value5":
          this.value6Focus();
          this.value6Select();
          break;
        case "value6":
          break;
        default:
          break;
      }
    }
  };

  value1Focus = () => {
    this.state.value1Ref.current.focus();
  };
  value2Focus = () => {
    this.state.value2Ref.current.focus();
  };
  value3Focus = () => {
    this.state.value3Ref.current.focus();
  };
  value4Focus = () => {
    this.state.value4Ref.current.focus();
  };
  value5Focus = () => {
    this.state.value5Ref.current.focus();
  };
  value6Focus = () => {
    this.state.value6Ref.current.focus();
  };

  value1Select = () => {
    this.state.value1Ref.current.select();
  };
  value2Select = () => {
    this.state.value2Ref.current.select();
  };
  value3Select = () => {
    this.state.value3Ref.current.select();
  };
  value4Select = () => {
    this.state.value4Ref.current.select();
  };
  value5Select = () => {
    this.state.value5Ref.current.select();
  };
  value6Select = () => {
    this.state.value6Ref.current.select();
  };

  VerifyOtpInBackend = () => {
    const { value1, value2, value3, value4, value5, value6 } = this.state;

    const otpValue = `${value1}${value2}${value3}${value4}${value5}${value6}`;

    if (otpValue.length !== 6) {
      return;
    }

    const postObject = {
      header: {},
      registration: {
        email: this.state.email,
        verificationcode: otpValue,
        customerOrderPaymentId: this.state.orderPaymentId,
      },
    };

    FetchServerData.callPostService(VerifyAccount_Url, postObject)
      .then((response) => {
        let output = response;
        let verifyData = output.data.registration;
        if (output.status === "SUCCESS") {
          const postObject = {
            header: {},
            registration: verifyData,
          };
          FetchServerData.callPostService(
            PostVerifyAccount_Url,
            postObject
          ).then((response) => {
            if (response.status === "SUCCESS") {
              let output = response.data;
              localStorage.clear();
              localStorage.removeItem("userId");
              localStorage.removeItem("password");
              localStorage.removeItem("selectedOption");
              localStorage.removeItem("rememberMe");
              store.dispatch(headerAction.setHeader(output.header));
              this.processLoginSuccess(output);
            }
          });
        }
      })
      .catch((error) => { });
  };

  processLoginSuccess(output_data) {
    store.dispatch(AppUserDataAction.setUserData(output_data));
    store.dispatch(AppUserDataAction.setUsage(output_data.smsCredits));
    store.dispatch(AppUserDataAction.setTollfreeNumber(output_data.tollfreeNumber));
    store.dispatch(AppUserDataAction.setTollfreeNumberStatus(output_data.tollFreeNumberStatus));
    store.dispatch(
      CrmIntegrationAction.setCrmIntegration(output_data.crmIntegration)
    );
    store.dispatch(
      AppUserDataAction.setOrganization(output_data.appuser?.organization)
    );
    let accountSetting = output_data?.accountSetting;
    store.dispatch(AccountSettingDataAction.setAccountSettingData({ accountSetting }));
    let logoData = {
      logo: output_data.appuser?.organization?.logo
        ? output_data.appuser?.organization?.logo
        : "",
      logoFilename: output_data.appuser?.organization?.logoFilename
        ? output_data.appuser?.organization?.logoFilename
        : "",
      logoFileextension: output_data.appuser?.organization?.logoFileextension
        ? output_data.appuser?.organization?.logoFileextension
        : "",
    };
    store.dispatch(AppUserDataAction.setLogo(logoData));
    if (output_data.isTollfreeNumberPurchased === true) {
      store.dispatch(SelectedTabAction.setSelectedTab(0));
    } else {
      store.dispatch(SelectedTabAction.setSelectedTab(1));
      if (output_data.cmpaigningInfoError) {
      }
    }
    let header = output_data.header;
    this.loadDashboardPage(header, output_data);
  }
  async loadDashboardPage(header, output) {
    let menus = output.appuser?.profile?.menus.sort(
      (a, b) => a.displaysequence - b.displaysequence
    );
    await this.setStaticData(header);
    store.dispatch(
      ActiveMenuAction.setActiveMenu(Utils.getArrayElement(menus, 0)?.pageid)
    );

    for (let i = 0; i < menus.length; i++) {
      const menu = menus[i];
      if (menu.isactive) {
        this.props.navigate(menu.pageid);
        break;
      }
    }
  }
  async setStaticData(header) {
    let StaticUrl = Utils.equalsIgnoreCase(
      this.state.businessDomain,
      BUSINESS_DOMAIN.eventText
    )
      ? StaticEventText_Url
      : Static_Url;
    const postObject = {
      header: header,
    };

    FetchServerData.callPostService(StaticUrl, postObject).then((output) => {
      if (output.status === "SUCCESS") {
        store.dispatch(staticDataAction.setStaticData(output.data));
      } else {
      }
    });
  }

  renderInputBox = (name, ref) => {
    return (
      <Col md={1} style={{ width: "60px", paddingLeft: "4px" }}>
        <input
          type="number"
          autoFocus={true}
          ref={this.state[ref]}
          className="form-control otpFormControlInput"
          id={"otpFormControlInput-" + name}
          maxLength="1"
          name={name}
          value={this.state[name]}
          onKeyUp={this.handleKeyUp}
          onChange={this.handleValueChange}
          aria-describedby="defaultFormControlHelp"
        />
      </Col>
    );
  };

  backToSignin() {
    this.props.history.push({
      pathname: "/login",
    });
  }

  ResendVerificationCode() {
    const postObject = {
      registration: {
        email: this.state.email,
      },
    };
    FetchServerData.callPostService(
      "/regms/resendVerificationCode",
      postObject
    ).then((response) => {
      if (response.status === "SUCCESS") {
        PtsAlert.success(response.message);
        this.setState({
          value1: "",
          value2: "",
          value3: "",
          value4: "",
          value5: "",
          value6: "",
        });
      } else {
      }
    });
  }

  render() {
    return (
      <>
        <Header />
        <div className="authentication-cover" style={{ padding: "2em" }}>
          <div
            className="authentication-inner row m-0"
            style={{ padding: "2em", minHeight: "65vh" }}
          >
            <div
              className="d-flex col-12 col-lg-6 col-xl-6 align-items-center leftBackground"
              style={{ textAlign: "center" }}
            >
              <div className="mx-auto">
                <img
                  src={Logo3}
                  className="img-fluid logoImage"
                  style={{ width: "50%" }}
                  alt=""
                  data-app-dark-img="illustrations/girl-with-laptop-dark.png"
                  data-app-light-img="illustrations/girl-with-laptop-light.png"
                />
                <h2 className="logoHeding"></h2>
              </div>
            </div>
            <div className="d-flex col-12 col-lg-6 col-xl-6 align-items-center authentication-bg p-4">
              <div>
                <div className="verifyAccountCardHeading ms-3">
                  Thank you for signing up for GivBee!
                </div>
                <p className="card-text ms-3" style={{ marginTop: "1em" }}>
                  A confirmation and verification code has been sent to your
                  phone and email. Please enter it here.
                </p>
                {/* <p className="card-text ms-3" style={{ marginTop: "1em" }}>
                  We’ve sent a confirmation and verification code to you by text
                  and email. Please enter the code below.
                </p>
                <p className="card-text ms-3" style={{ marginTop: "0.5em" }}>
                  If you do not receive your confirmation email/sms, please
                  check your spam or junk mail box of your email client.
                </p>
                <p className="card-text ms-3" style={{ marginTop: "0.5em" }}>
                  Please enter verification code sent to email and Mobile:
                  <b> {this.state.email}</b>
                </p> */}
                <p className="heding-1">Verification Code</p>
                <Row style={{ margin: "0.6em 0.6em 0.6em 1em" }}>
                  {this.renderInputBox("value1", "value1Ref")}
                  {this.renderInputBox("value2", "value2Ref")}
                  {this.renderInputBox("value3", "value3Ref")}
                  {this.renderInputBox("value4", "value4Ref")}
                  {this.renderInputBox("value5", "value5Ref")}
                  {this.renderInputBox("value6", "value6Ref")}
                  {/* <span className="mt-2 pe-0">
                    <NavLink
                      className="naveLink"
                      onClick={this.ResendVerificationCode.bind(this)}
                      style={{ float: "right", marginBottom: "10px" }}
                    >
                      <span>Resend Code</span>
                    </NavLink>
                  </span> */}
                </Row>
                <div className="row">
                  <div style={{ width: "387px" }}>
                    <span className="mt-2 pe-0">
                      <NavLink
                        className="naveLink"
                        onClick={this.ResendVerificationCode.bind(this)}
                        style={{ float: "right", marginBottom: "10px" }}
                      >
                        <span>Resend Code</span>
                      </NavLink>
                    </span>
                  </div>
                </div>

                <div className="ms-3">
                  <button
                    className="submit"
                    size="small"
                    style={{ textTransform: "capitalize" }}
                    onClick={this.VerifyOtpInBackend.bind(this)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default withRouter(VerifyAccount);
